/**
 * Palmiye Gurme — mega menü kategori vitrini (Tur 7)
 * Kategori satırının üzerine gelince / odaklanınca sağdaki vitrin o kategoriye geçer.
 * Fareyle çapraz geçişte yanlış kategoriye atlamamak için kısa bir niyet gecikmesi kullanılır.
 * Klavye: ↑/↓ kategoriler arasında gezinir, Enter bağlantıyı açar.
 */
(() => {
  if (window.__pgMega) return;
  window.__pgMega = true;

  const INTENT_MS = 90;

  function activate(cat) {
    const mega = cat.closest('[data-pg-mega]');
    if (!mega || cat.classList.contains('is-active')) return;
    const targetId = cat.dataset.pgMegaTarget;
    mega.querySelectorAll('.pg-mega__cat').forEach((el) => {
      const on = el === cat;
      el.classList.toggle('is-active', on);
      if (on) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });
    mega.querySelectorAll('.pg-mega__panel').forEach((panel) => {
      panel.hidden = panel.id !== targetId;
    });
  }

  let timer = null;
  document.addEventListener('pointerover', (e) => {
    const cat = e.target.closest?.('.pg-mega__cat');
    if (!cat) return;
    clearTimeout(timer);
    timer = setTimeout(() => activate(cat), INTENT_MS);
  });
  document.addEventListener('pointerout', (e) => {
    if (e.target.closest?.('.pg-mega__cat')) clearTimeout(timer);
  });
  document.addEventListener('focusin', (e) => {
    const cat = e.target.closest?.('.pg-mega__cat');
    if (cat) activate(cat);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    const cat = e.target.closest?.('.pg-mega__cat');
    if (!cat) return;
    const items = [...cat.closest('.pg-mega__list').querySelectorAll('.pg-mega__cat')];
    const i = items.indexOf(cat);
    const next = items[(i + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
    e.preventDefault();
    next.focus();
  });
})();
